'use strict';

const getSid = (number) => {
  const plus = number.substring(0, 1);
  if (plus === '+') return number.substring(1);
  else return `${number.length <= 11 ? '55' : ''}${number}`;
};

module.exports = getSid;
